import { render } from "./DialogFoggetPassword.vue?vue&type=template&id=e8d60f38"
import script from "./DialogFoggetPassword.vue?vue&type=script&lang=js"
export * from "./DialogFoggetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/home/ctis-desenvolvimento/Projetos/front-end/piso-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__